import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { map, takeUntil } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';
@Injectable({
    providedIn: 'root'
  })
export class BatchService extends Subject<DataStateChangeEventArgs>{
  batchData: any = [];
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private http: HttpClient, private ngxService: NgxUiLoaderService, public errorService: ErrorService, public global: GlobalComponent, public general: GeneralService) {
    super();
  }
  public outputValues(state): void {
    this.getBatch(state).subscribe(x => super.next(x));
  }
  getBatch(state): Observable<DataStateChangeEventArgs> {
    let url = "api/BatchFile/GetBatchFile?";
    return this.http.post<any>("api/BatchFile/GetBatchFile", state).pipe(takeUntil(this.onDestroy$))
      .pipe(map(
        (response: any) =>
        (<any>{
          result: response['batchList'],
          count: response['totalCount']
        }
        ))).pipe(map((e: any) => {
          return e;
        })
        )
  }
  getbatchData() {
    return this.batchData;
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
